export default __webpack_public_path__ + "static/media/ElectroStaticImg.4fc75a8b.jpg";